import React, {Component} from "react";
import "./App.css";
import Header from "./Layouts/Header";
import Footer from "./Layouts/Footer";
import Router from "./Routes/Router";
import Spinner from "./Components/UI/Spinner/Spinner";
import { connect } from "react-redux";
import * as actions from "./store/index";

class App extends React.Component {
   componentDidMount() {
    this.props.onFetchContries();
  }
  render() {
    return (
      <div className="App">
        <div
          className="spinner"
          style={{ display: this.props.loader === false ? "none" : "block" }}
        >
          <Spinner />
        </div>
        <Header />
        <Router />
        <Footer />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    loader: state.loader,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onFetchContries: () => dispatch(actions.fetchContries())
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);